const buildAnchor = (reportKey, sectionKey) => `sa-${reportKey}-${sectionKey}`;

export const getSuperAdminHelpAnchors = (reportKey) => ({
  overview: buildAnchor(reportKey, "overview"),
  filters: buildAnchor(reportKey, "filters"),
  kpis: buildAnchor(reportKey, "kpis"),
  details: buildAnchor(reportKey, "details"),
  export: buildAnchor(reportKey, "export"),
  troubleshooting: buildAnchor(reportKey, "troubleshooting"),
});

export const buildSuperAdminReportHelpGuide = ({
  reportKey,
  title,
  subtitle,
  hasExport = true,
  summaryLabel = "KPIs and Summary",
  detailsLabel = "Details",
}) => {
  const anchors = getSuperAdminHelpAnchors(reportKey);
  const exportDescription = hasExport
    ? "Download a CSV of the current results."
    : "This report does not support export.";
  const exportBullets = hasExport
    ? ["Run the report first.", "Use Export to download a CSV file."]
    : ["Use filters to narrow results.", "Export is not available for this report."];

  return {
    title: `Help Guide: ${title}`,
    subtitle,
    sections: [
      {
        id: "overview",
        title: "Overview",
        description: "Review system-wide results for the selected scope and date range.",
        anchorId: anchors.overview,
        bullets: [
          "Choose a scope to control which salons are included.",
          "Run the report to load summary metrics and details.",
        ],
        tips: ["Keep scope and date range consistent when comparing periods."],
      },
      {
        id: "scope-and-filters",
        title: "Scope and Filters",
        description: "Set scope, business or salon, date range, and filter options.",
        anchorId: anchors.filters,
        bullets: [
          "Scope controls all salons, one business, or one salon.",
          "Date presets use each salon's accounting date.",
        ],
        tips: ["If scope is Business or Salon, select the matching entity first."],
      },
      {
        id: "kpis-or-summary",
        title: summaryLabel,
        description: "Check the top-level metrics for the selected range.",
        anchorId: anchors.kpis,
        bullets: ["Use summary tiles to spot changes quickly."],
        tips: ["Use consistent filters when comparing totals."],
      },
      {
        id: "details",
        title: detailsLabel,
        description: "Review the detailed table or chart for the full breakdown.",
        anchorId: anchors.details,
        bullets: ["Sort or scan the detailed rows for patterns."],
        tips: ["Narrow filters before diving into the details."],
      },
      {
        id: "export",
        title: "Export",
        description: exportDescription,
        anchorId: anchors.export,
        bullets: exportBullets,
        tips: ["Run the report again after changing filters."],
      },
    ],
    troubleshooting: [
      {
        title: "Numbers look off",
        body: "Confirm scope, date range, and timezone rules for the selected salons.",
      },
      {
        title: "No data returned",
        body: "Widen the date range or switch scope to confirm data exists.",
      },
      {
        title: hasExport ? "Export is empty" : "Export unavailable",
        body: hasExport
          ? "Run the report first and ensure results are visible before exporting."
          : "This report does not offer export. Use filters and on-screen totals.",
      },
    ],
  };
};
